if(typeof campaign_cf7_controller == 'undefined'){
    var campaign_cf7_controller = {
        params: {},
        fields: [
            'utm_source',
            'utm_medium',
            'utm_campaign'
        ],
        get_params: function(){
            var url = new URL(window.location);
            var s = url.search;
            if(s.length == 0){
                return;
            }else{
                s = s.split('&');
                s[0] = s[0].replace('?', '');
                var params = {};
                for(var i = 0; i < s.length; i++){
                    var temp = s[i].split('=');
                    temp[0] = temp[0].toLowerCase();
                    params[temp[0]] = decodeURI(temp[1]);
                }
                campaign_cf7_controller.params = params;
            }
        },
        set_values: function(){
            campaign_cf7_controller.get_params();
            for(var i = 0; i < campaign_cf7_controller.fields.length; i++){
                var field = campaign_cf7_controller.fields[i];
                if(typeof campaign_cf7_controller.params[field] != 'undefined'){
                    var input = document.getElementById("input_"+field);
                    input.value = campaign_cf7_controller.params[field];
                }
            }
        }
    };
}

if(typeof product_cf7_controller == 'undefined'){
    var product_cf7_controller = {
        targetProductValue: null,
        observer: null,
        checkTimeout: null,
        parse_params: function(){
            var url = new URL(window.location);
            var s = url.search;
            if(s.length == 0){
                return null;
            }else{
                s = s.split('&');
                s[0] = s[0].replace('?', '');
                var params = {};
                for(var i = 0; i < s.length; i++){
                    var temp = s[i].split('=');
                    temp[0] = temp[0].toLowerCase();
                    params[temp[0]] = decodeURI(temp[1]);
                }
                return params;
            }
        },
        set_product_value: function(input, value){
            if(!input || !value) return false;
            
            var product_exist = input.querySelector("option[data-value='"+value+"']");
            if(product_exist){
                // Use jQuery to set value if available (more reliable with CF7)
                if(typeof jQuery !== 'undefined'){
                    jQuery(input).val(product_exist.value).trigger('change');
                } else {
                    input.value = product_exist.value;
                    var event = new Event('change', { bubbles: true });
                    input.dispatchEvent(event);
                }
                return true;
            }
            return false;
        },
        check_url: function(){
            var params = product_cf7_controller.parse_params();
            if(params && typeof params['select_product'] != 'undefined'){
                var input = document.querySelector("select[name='product']");
                if(input){
                    // Store the target value for persistence
                    product_cf7_controller.targetProductValue = params['select_product'];
                    return product_cf7_controller.set_product_value(input, params['select_product']);
                }
            }
            return false;
        },
        watch_for_resets: function(){
            // Watch for form resets and re-apply the product value
            var input = document.querySelector("select[name='product']");
            if(!input || !product_cf7_controller.targetProductValue) return;
            
            // Get the expected option value for comparison
            var targetOption = input.querySelector("option[data-value='"+product_cf7_controller.targetProductValue+"']");
            if(!targetOption) return;
            var expectedValue = targetOption.value;
            
            // Use MutationObserver to watch for form DOM changes
            if(product_cf7_controller.observer){
                product_cf7_controller.observer.disconnect();
            }
            
            var checkAndRestore = function(){
                var currentInput = document.querySelector("select[name='product']");
                if(currentInput && product_cf7_controller.targetProductValue){
                    var currentValue = currentInput.value;
                    // Only restore if value is empty/default (indicating a reset)
                    // Don't override user's manual selection
                    if(currentValue === '' || currentValue === '0' || currentValue === null || currentValue === undefined){
                        product_cf7_controller.set_product_value(currentInput, product_cf7_controller.targetProductValue);
                    }
                }
            };
            
            product_cf7_controller.observer = new MutationObserver(function(mutations){
                // Debounce the check
                clearTimeout(product_cf7_controller.checkTimeout);
                product_cf7_controller.checkTimeout = setTimeout(checkAndRestore, 100);
            });
            
            // Watch the select element and its parent form
            var form = input.closest('form');
            if(form){
                product_cf7_controller.observer.observe(form, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
            }
            
            // Also watch the select directly for value changes
            if(typeof jQuery !== 'undefined'){
                jQuery(input).on('change', function(){
                    setTimeout(checkAndRestore, 50);
                });
            }
            
            // Periodic check as backup (every 500ms for first 5 seconds)
            var periodicChecks = 0;
            var periodicInterval = setInterval(function(){
                periodicChecks++;
                checkAndRestore();
                if(periodicChecks >= 10){
                    clearInterval(periodicInterval);
                }
            }, 500);
        },
        init_product_selection: function(){
            // Store target value from URL
            var params = product_cf7_controller.parse_params();
            if(params && typeof params['select_product'] != 'undefined'){
                product_cf7_controller.targetProductValue = params['select_product'];
            }
            
            // Try immediately
            if(product_cf7_controller.check_url()){
                product_cf7_controller.watch_for_resets();
                return;
            }
            
            // If form not ready, wait for CF7 to load
            var attempts = 0;
            var maxAttempts = 50; // 5 seconds max (50 * 100ms)
            
            var trySetProduct = function(){
                attempts++;
                if(product_cf7_controller.check_url()){
                    product_cf7_controller.watch_for_resets();
                    return;
                }
                if(attempts < maxAttempts){
                    setTimeout(trySetProduct, 100);
                } else if(product_cf7_controller.targetProductValue){
                    // Even if we couldn't set it, start watching
                    product_cf7_controller.watch_for_resets();
                }
            };
            
            // Start retry mechanism
            setTimeout(trySetProduct, 100);
        },
        event_bind: function(){
            // Listen for CF7 form loaded events to set product after form initialization
            jQuery(document).on('wpcf7loaded wpcf7:domready wpcf7beforesubmit', function(event){
                if(product_cf7_controller.targetProductValue){
                    product_cf7_controller.check_url();
                }
            });
            
            // Listen for form reset/refresh events
            jQuery('body').on('wpcf7mailsent wpcf7mailfailed wpcf7invalid wpcf7spam', function(){
                // Re-apply product value after form events
                if(product_cf7_controller.targetProductValue){
                    setTimeout(function(){
                        product_cf7_controller.check_url();
                    }, 100);
                }
            });
            
            jQuery('body').on('wpcf7:invalid wpcf7invalid', function(event){
                if(typeof event.originalEvent != 'undefined' && event.originalEvent.detail != undefined && event.originalEvent.detail.apiResponse != undefined){
                    var apiResponse = event.originalEvent.detail.apiResponse;
                    if(typeof apiResponse.invalid_fields != 'undefined'){
                        for(var i = 0; i < apiResponse.invalid_fields.length; i++){
                            var field = apiResponse.invalid_fields[i];
                            if(field.field == 'product'){
                                var $input = jQuery("select[name='product']");
                                $input.addClass('wpcf7-not-valid');
                                $input.closest('.wpcf7-form-control-wrap').append('<span class="wpcf7-not-valid-tip">' + field.message + '</span>');
                                break;
                            }
                        }
                    }
                }
            });
            jQuery(document).on('syn:fetch-error:wpcf7', function(e){
                console.log('Fetch error detected');
                console.log(e.response);
            });
            jQuery('form').on('submit change', function(){
                var $form = jQuery(this);
                var $input = $form.find("select[name='product']");
                var $wrapper = $input.closest('.wpcf7-form-control-wrap');
                $input.removeClass('wpcf7-not-valid');
                $wrapper.find('.wpcf7-not-valid-tip').remove();
            });
        }
    };
}

var dialog_controller = {
    close_closest_dialog: function(dom){
		var $dialog = jQuery(dom).closest('dialog');
		$dialog[0].close();
		$dialog.remove(); //Remove the dialog from the DOM
	},
    loading_closest_dialog: function(dom){
        var $dialog = jQuery(dom).closest('dialog');
        $dialog.addClass('loading');
    },
    loaded_closest_dialog: function(dom){
        var $dialog = jQuery(dom).closest('dialog');
        $dialog.removeClass('loading');
    },
	display_dialog: function(message, controls, css_class){
        if(typeof css_class == 'undefined'){
            css_class = '';
        }else{
            css_class = ' ' + css_class;
        }
		var $dialog = jQuery('<dialog class="syn-dialog'+css_class+'"></dialog>');

        if(
            typeof message.header == 'undefined' 
            || message.header === true){
            var dialog_template = '<header><button class="close-dialog"><i class="icon icon-ui-plus"></i></button></header>';
        }else{
            var dialog_template = '';
        }
        
        if (message.title) {
            dialog_template += '<span class="title">' + message.title + '</span>';
        }

        if (message.content) {
            dialog_template += '<div class="message">' + message.content + '</div>';
        }

		$dialog.html(dialog_template);
		$dialog.find('.close-dialog').on('click', function(){
			dialog_controller.close_closest_dialog(this);
		});
		if(typeof controls != 'undefined' && controls.length > 0){
			$dialog.append('<div class="controls"></div>');
			for(var i = 0; i < controls.length; i++){
                var class_string = '';
                if(controls[i].class){
                    class_string = ' ' + controls[i].class;
                }

                var base_class = 'cta cta-button dialog-control alt';
                if(typeof controls[i].inline != 'undefined' && controls[i].inline === true){
                    base_class = 'cta cta-inline dialog-control alt';
                }

				var $control = jQuery('<button class="' + base_class + class_string+'">' + controls[i].text + '</button>');
				$control.on('click', controls[i].callback);
				$dialog.find('.controls').append($control);
			}
		}
		$dialog.appendTo('body');
		$dialog[0].showModal();

        //Return the dialog so that it can be manipulated further if needed.
        return $dialog;
	},
};

window.dialog_controller = dialog_controller;

var form_error_controller = {
    display_error: function(message){
        dialog_controller.display_dialog({
            title: '<strong>Error</strong>',
            content: message,
        }, [{
            text: 'OK',
            callback: function(){
                dialog_controller.close_closest_dialog(this);
            },
        }], 'syn-dialog--small');
    },
    init: function(){
        jQuery(document.body).on('wpcf7:invalid wpcf7:spam wpcf7spam wpcf7mailfailed', function(data){
            var message = data.detail.apiResponse.message;
            form_error_controller.display_error(message);
        });
        window.fetch = new Proxy(window.fetch, {
            apply(actualFetch, that, args) {
                // Forward function call to the original fetch

                const result = Reflect.apply(actualFetch, that, args);
                result.then((response) => {
                    if(response.status >= 400 && args[0].search('contact-form-7') > -1){
                        form_error_controller.display_error('There was an error submitting the form. Please try again later.');
                        jQuery('.wpcf7-form').trigger('loader:hide').removeClass('submitting');
                    }
                });

                return result;
            }
        });
    }
};

window.form_error_controller = form_error_controller;

campaign_cf7_controller.set_values();

jQuery(document).ready(function(){
    product_cf7_controller.event_bind();
    form_error_controller.init();
    // Initialize product selection with retry mechanism
    product_cf7_controller.init_product_selection();
});